/**
 * DCV (Domain Control Validation) method identifiers.
 * Shared across route validation, service logic, and frontend UI.
 */
export const DCV_METHODS = {
  CNAME: "cname",
  TXT: "txt",
  HTTP: "http",
  HTTPS: "https",
};

/**
 * Ordered list of all valid DCV methods for validation rules.
 */
export const DCV_METHOD_LIST = [
  DCV_METHODS.CNAME,
  DCV_METHODS.TXT,
  DCV_METHODS.HTTP,
  DCV_METHODS.HTTPS,
];

/**
 * Default DNS record name prefix used for CNAME/TXT validation
 * when the user does not specify a custom record name.
 */
export const DEFAULT_DNS_RECORD_PREFIX = "_dnsauth";
